import {
    VIDFLEET_CAMERA_LOGS_REQUEST,
    VIDFLEET_CAMERA_LOGS_RESULT,
} from 'Redux/actionTypes';

export const cameraLogsRequest = (filters) => ({
    type: VIDFLEET_CAMERA_LOGS_REQUEST,
    payload: { filters }
});

export const cameraLogsResult = (data) => ({
    type: VIDFLEET_CAMERA_LOGS_RESULT,
    payload: data
});
